import { Workshop } from '@/@types/workshop'
import { isWorkshopExpired } from '@/helpers/workshop'
import { router } from '@inertiajs/vue3'
import { ref } from 'vue'

export function useExpiredWorkshopDialog() {
  const selectedWorkshop = ref<Workshop | null>(null)
  const showExpiredConfirmation = ref(false)

  function openWorkshop(workshop: Workshop, navigateTo: string = 'orders') {
    router.visit(`/admin/${navigateTo}?workshop_id=${workshop.id}`)
  }

  function handleWorkshopClick(workshop: Workshop, navigateTo: string = 'orders') {
    if (!isWorkshopExpired(workshop)) {
      openWorkshop(workshop, navigateTo)
      return
    }

    selectedWorkshop.value = workshop
    showExpiredConfirmation.value = true
  }

  function closeExpiredConfirmation() {
    showExpiredConfirmation.value = false
    selectedWorkshop.value = null
  }

  function onExpiredDialogClose() {
    showExpiredConfirmation.value = false
  }

  function confirmExpiredNavigation(navigateTo: string = 'orders') {
    const workshop = selectedWorkshop.value
    closeExpiredConfirmation()

    if (workshop) {
      openWorkshop(workshop, navigateTo)
    }
  }

  return {
    selectedWorkshop,
    showExpiredConfirmation,
    handleWorkshopClick,
    closeExpiredConfirmation,
    onExpiredDialogClose,
    confirmExpiredNavigation,
  }
}
